import { render, staticRenderFns } from "./SaveAlertModal.vue?vue&type=template&id=5999fa5c&scoped=true&"
import script from "./SaveAlertModal.vue?vue&type=script&lang=js&"
export * from "./SaveAlertModal.vue?vue&type=script&lang=js&"
import style0 from "./SaveAlertModal.vue?vue&type=style&index=0&id=5999fa5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5999fa5c",
  null
  
)

export default component.exports